import React from "react";

import s from "./ui.module.scss";

export type BadgeTone = "neutral" | "brand" | "success" | "warning" | "danger" | "info";

const TONE: Record<BadgeTone, string> = {
  neutral: s.badgeNeutral,
  brand: s.badgeBrand,
  success: s.badgeSuccess,
  warning: s.badgeWarning,
  danger: s.badgeDanger,
  info: s.badgeInfo,
};

interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  children: React.ReactNode;
}

const Badge = ({ tone = "neutral", className, children }: BadgeProps) => (
  <span className={[s.badge, TONE[tone], className].filter(Boolean).join(" ")}>{children}</span>
);

export default Badge;
